import { Composition } from "atomic-layout"
import * as React from "react"
import { gap } from "../../../utils/spacing"
import Container from "../../atoms/Container"
import Background from "../../molecules/Background"
import ImageWithText, { ImageWithTextProps } from "../../organisms/ImageWithText"
import { LinkProps } from "../../../types/types"

type ImageWithTextSectionProps = {
  heading?: React.ReactNode,
  backgroundColor?: string,
  items?: ImageWithTextProps[],
  columns?: number,
  templateCols?: object,
}

const ImageWithTextSection = ({
                                heading = null,
                                backgroundColor,
                                items,
                                columns = 1,
                                templateCols = null
                              }: ImageWithTextSectionProps) => {
  const templateColProps = templateCols || {
    templateCols: "1fr",
    templateColsMd: `repeat(${columns}, minmax(0, 1fr))`
  }

  const isSmallContainer = columns === 1 && items[0].imagePosition === "Top"

  return (
    <Container background={backgroundColor && <Background color={backgroundColor} />} small={isSmallContainer}>
      <Composition
        {...templateColProps}
        gapRow={"calc(var(--section-spacing) * 0.75)"}
        gapCol={38}
      >
        {items.map((item, index) => {
          const { image, video, buttonText, buttonUrl, heading, overline, imagePosition, text, logo, textAlignment } = item

          return (
            <ImageWithText
              key={heading + index.toString()}
              image={image}
              text={text}
              heading={heading}
              overline={overline}
              buttonText={buttonText}
              buttonUrl={buttonUrl}
              imagePosition={imagePosition}
              logo={logo}
              video={video}
              showOffset={columns === 1}
              textAlignment={textAlignment}
            />
          )
        })}
      </Composition>
    </Container>
  )
}

export default ImageWithTextSection
